// extracted by mini-css-extract-plugin
export var about = "apps-module--about--cAYG4";
export var aboutCenter = "apps-module--about-center--Kj5Ap";
export var aboutImg = "apps-module--about-img--0VABW";
export var aboutInfo = "apps-module--about-info--EpgKV";
export var imgContainer = "apps-module--img-container----bz6";